<script>
    import { Icon as SvelteIcon } from 'svelte-icon';

    let { data, ...rest } = $props();
</script>

<SvelteIcon {data} aria-hidden="true" {...rest} />
